import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { de } from 'date-fns/locale';

export function provideDeDateFormat(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: DateAdapter,
      useClass: DateFnsAdapter,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: de,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: [
            'dd.MM.yy',
            'dd.MM.yyyy',
            'dd/MM/yy',
            'dd/MM/yyyy',
            'ddMMyy',
            'ddMMyyyy',
          ],
        },
        display: {
          dateInput: 'dd.MM.yyyy',
          monthYearLabel: 'MMM yyyy',
          dateA11yLabel: 'dd.MM.yyyy',
          monthYearA11yLabel: 'MMMM yyyy',
        },
      },
    },
  ]);
}
